import React from "react";
import DoneIcon from "@mui/icons-material/Done";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
function LoadingPage({
  status,
}: {
  status: "idle" | "loading" | "success" | "error";
}) {
  return (
    <div className="h-full pt-28 w-full flex gap-24 justify-center items-center">
      <div className="flex flex-col gap-4">
        <div
          className={`${
            status === "success" ? "opacity-100" : "opacity-50"
          } flex gap-12 justify-between`}
        >
          <p>Loading all country profiles</p>
          {status === "success" ? (
            <DoneIcon style={{ opacity: 1 }} />
          ) : (
            <DoneIcon style={{ opacity: 0 }} />
          )}
        </div>
      </div>

      <LoadingSpinner />
    </div>
  );
}

export default LoadingPage;
